"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedObjectUnderLenientControl = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ComponentLabelsContext_1 = require("./ComponentLabelsContext");
var SharedObjectCheckboxControl_1 = require("./SharedObjectCheckboxControl");
/**
 * @internal
 */
exports.SharedObjectUnderLenientControl = function (_a) {
    var isUnderLenientControl = _a.isUnderLenientControl, isLeniencyControlSupported = _a.isLeniencyControlSupported, onUnderLenientControlChange = _a.onUnderLenientControlChange;
    var labels = ComponentLabelsContext_1.useComponentLabelsContext();
    return (react_1.default.createElement(SharedObjectCheckboxControl_1.SharedObjectCheckboxControl, { isChecked: isUnderLenientControl, isSupported: isLeniencyControlSupported, onChange: onUnderLenientControlChange, label: labels.accessRegimeLabel, name: "shared-accessRegimeLabel-control", className: "s-shared-object-under-lenient-control" }));
};
//# sourceMappingURL=SharedObjectUnderLenientControl.js.map